import { Search } from "@mui/icons-material";
import { Box, Chip, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterIcon, PlusHeaderIcon } from "../../assets/customIcons";
import { getUpdateKey } from "../../builderPackage/common/commonFunctions";
import { DynamicFormBuilderContainer } from "../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../components/molecules/desktopTabComponent";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { setReducerState } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { ContractSaleOrderKeys } from "../contractSaleOrder/services/entity";
import { ContractSaleInvoiceCatalogueInvoicedMobileView } from "./components/contractSaleInvoiceCatalogueInvoicedMobileView";
import { ContractSaleInvoiceCatalogueOpenMobile } from "./components/contractSaleInvoiceCatalogueOpenMobile";
import InvoicedCatalogueView from "./components/invoicedCatalogueView";
import OpenOrderCatalogueView from "./components/openOrderCatalogueView";
import ReturnedCatalogueView from "./components/returnedCatalogueView";
import { InvoiceCountAPI } from "./services/apiCall";
import { ContractInvoiceKeys } from "./services/entity";
var ContractSaleinvoice = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _crud$ContractInvoice, _crud$ContractInvoice2, _crud$ContractInvoice3, _crud$ContractInvoice4;
    var _a = useState(false), isFilterOpen = _a[0], setFilterOpen = _a[1];
    var _b = useState('list'), activeView = _b[0], setActiveView = _b[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var IdentityId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.IdentityId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var listVariants = [{
            Name: "My contract sales invoice",
            id: IdentityId
        }, {
            Name: 'All contract sales invoice',
            id: 'all'
        }];
    var openCatalogueView = [{
            type: FormItemTypes.Custom,
            name: 'open',
            columnSize: 12,
            element: IS_MOBILE ? ContractSaleInvoiceCatalogueOpenMobile : OpenOrderCatalogueView
        }];
    var invoicedCatalogueView = [{
            type: FormItemTypes.Custom,
            name: 'invoiced',
            columnSize: 12,
            element: IS_MOBILE ? ContractSaleInvoiceCatalogueInvoicedMobileView : InvoicedCatalogueView
        }];
    var returnedCatalogueView = [{
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 12,
            element: ReturnedCatalogueView
        }];
    var handleOnClick = function () {
        navigate('/createContractSaleInvoice');
    };
    var formData = [{
            type: FormItemTypes.SingleSelect,
            name: 'IdentityId',
            value: 'all',
            options: listVariants,
            valueExpr: 'id',
            displayExpr: 'Name',
            size: 'small',
            columnSize: 0,
            disableUnderline: true,
            variant: 'standard',
            sx: {
                color: 'text.primary',
                m: 1,
                fontWeight: 'strong',
                fontSize: 'xxl',
                bgcolor: 'secondary.50'
            }
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by VIN, Reg No, Doc No..',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: IS_MOBILE ? 2 : 9,
                    gap: IS_MOBILE ? '0px' : '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!IS_MOBILE ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true,
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null)
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, !IS_MOBILE ? {
                            type: FormItemTypes.Button,
                            name: 'Newbtn',
                            children: 'New',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'contained',
                            // startIcon: <PlusIcon/>,
                            sx: {
                                padding: '8px'
                            },
                            onClick: handleOnClick
                        } : null]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Status',
            columnSize: 12,
            valueExpr: 'id',
            sx: {
                px: 2
            },
            displayExpr: 'Name',
            panelGridProps: {
                spacing: 2,
                pb: '65px'
            },
            tabs: [
                // {
                //     id: 'openOrder',
                //     Name: 'Open order',
                //     elements: openCatalogueView,
                // },
                {
                    id: 'openOrder',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Open order"), /*#__PURE__*/ React.createElement(Chip, {
                        label: (_crud$ContractInvoice = (_crud$ContractInvoice2 = crud[ContractInvoiceKeys.ContractSaleInvoiceCount]) === null || _crud$ContractInvoice2 === void 0 || (_crud$ContractInvoice2 = _crud$ContractInvoice2.data) === null || _crud$ContractInvoice2 === void 0 ? void 0 : _crud$ContractInvoice2.Open) !== null && _crud$ContractInvoice !== void 0 ? _crud$ContractInvoice : '0',
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: openCatalogueView
                },
                // {
                //     id: 'invoiced',
                //     Name: 'Invoiced',
                //     elements: invoicedCatalogueView
                // },
                {
                    id: 'invoiced',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Invoiced"), /*#__PURE__*/ React.createElement(Chip, {
                        label: (_crud$ContractInvoice3 = (_crud$ContractInvoice4 = crud[ContractInvoiceKeys.ContractSaleInvoiceCount]) === null || _crud$ContractInvoice4 === void 0 || (_crud$ContractInvoice4 = _crud$ContractInvoice4.data) === null || _crud$ContractInvoice4 === void 0 ? void 0 : _crud$ContractInvoice4.Invoiced) !== null && _crud$ContractInvoice3 !== void 0 ? _crud$ContractInvoice3 : '0',
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: invoicedCatalogueView
                }, {
                    id: 'returned',
                    Name: 'Returned'
                    // elements: returnedCatalogueView    // For Now Returned tab is commented
                }
            ]
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Newbtn',
                    children: 'New',
                    columnSize: 12,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'contained',
                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                    onClick: handleOnClick
                }]
        } : null];
    var handleClickFilterIcon = function () {
        setFilterOpen(true);
    };
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: InvoiceCountAPI,
        getKey: ContractInvoiceKeys.ContractSaleInvoiceCount,
        getRequest: {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            if ((state === null || state === void 0 ? void 0 : state.Status) == "invoiced") {
                if (field && value)
                    dispatch(setReducerState({
                        key: getUpdateKey(ContractInvoiceKeys.Paging),
                        value: true
                    }));
            }
            else if ((state === null || state === void 0 ? void 0 : state.Status) == "openOrder") {
                if (field && value)
                    dispatch(setReducerState({
                        key: getUpdateKey(ContractSaleOrderKeys.Paging),
                        value: true
                    }));
            }
        }
    }));
};
export default ContractSaleinvoice;
